export default {
  ACCORDION_SECTION: 'AccordionSection',
  INPUT_WITH_MENTIONS: 'InputWithMentions',
  ACTION_WITH_SYMBOL: 'ActionWithSymbol',
  ACTIONS_LIST_ITEM: 'ActionsListItem',
  ADDABLE_LIST_ITEM: 'AddableListItem',
  ANGLE_INPUT: 'AngleInput',
  ADD_THUMBNAIL_BUTTON: 'AddThumbnailButton',
  BACK_BUTTON: 'BackButton',
  BADGE: 'Badge',
  BASE_MODAL: 'BaseModal',
  BASE_MODAL_FOOTER: 'BaseModalFooter',
  BASE_MODAL_HEADER: 'BaseModalHeader',
  HEADER_BACK_BUTTON: 'HeaderBackButton',
  BUBBLE: 'Bubble',
  BUTTON: 'Button',
  BUTTON_CONTENT: 'ButtonContent',
  BUTTONS_GROUP: 'ButtonsGroup',
  CLOSE_BUTTON: 'CloseButton',
  CHECKBOX: 'Checkbox',
  CHOOSE_COLOR_DIALOG: 'ChooseColorDialog',
  COLLAPSE_LABEL: 'CollapseLabel',
  COLOR_FORMAT: 'ColorFormat',
  COLOR_SPACE: 'ColorSpace',
  COLOR_PICKER_INPUT: 'ColorPickerInput',
  CONTEXT_MENU: 'ContextMenu',
  CONTEXT_MENU_ACTION: 'ContextMenuAction',
  CONTEXT_MENU_FOLDER: 'ContextMenuFolder',
  CONTEXT_MENU_CONTENT: 'ContextMenuContent',
  CONTEXTUAL_DIVIDER: 'ContextualDivider',
  CORVID_VERTICAL_PANE: 'CorvidVerticalPane',
  CORNER: 'Corner',
  CORNER_RADIUS_INPUT: 'CornerRadiusInput',
  COUNTER_BADGE: 'CounterBadge',
  CUSTOM_MODAL: 'CustomModal',
  DATE_PICKER: 'DatePicker',
  DATE_PICKER_INPUT: 'DatePickerInput',
  DIVIDER: 'Divider',
  DOCK: 'Dock',
  DOCK_DIRECTION: 'DockDirection',
  DOCKING_PANEL: 'DockingPanel',
  DOCKING_PLANE_BUTTON: 'DockingPlaneButton',
  DRILL_IN_LIST_ITEM: 'DrillInListItem',
  DROP_DOWN: 'DropDown',
  DROP_DOWN_BASE: 'DropDownBase',
  DROP_DOWN_BASE_OPTIONS: 'DropDownBaseOptions',
  DROP_DOWN_DETAILED_OPTION: 'DropDownDetailedOption',
  DROP_DOWN_OPTION: 'DropDownOption',
  DROP_DOWN_SECTION: 'DropDownSection',
  DROP_DOWN_STICKY_FOOTER: 'DropDownStickyFooter',
  DROP_DOWN_CHECKBOX_CONTAINER: 'DropDownCheckboxContainer',
  DROP_DOWN_THEME_OPTION: 'DropDownThemeOption',
  DROP_DOWN_ILLUSTRATION_OPTION: 'DropDownIllustrationOption',
  DROP_DOWN_LIST_ITEM_OPTION: 'DropDownListItemOption',
  ROUNDED_ILLUSTRATION_CONTAINER: 'RoundedIllustrationContainer',
  DYNAMIC_FIELD: 'DynamicField',
  EDITABLE_LIST_ITEM: 'EditableListItem',
  EDITABLE_URL: 'EditableUrl',
  FONT_FAMILY_PICKER: 'FontFamilyPicker',
  GOOGLE_PREVIEW: 'GooglePreview',
  HELP_BUTTON: 'HelpButton',
  HORIZONTAL_TABS: 'HorizontalTabs',
  ILLUSTRATION: 'Illustration',
  RADIO_BUTTONS_WITH_ILLUSTRATION: 'RadioButtonsWithIllustration',
  IMAGE_AND_TEXT_TEMPLATE: 'ImageAndTextTemplate',
  INFO_ICON: 'InfoIcon',
  MESSAGE_MODAL: 'MessageModal',
  MY_COLORS: 'MyColors',
  NUMERIC_INPUT: 'NumericInput',
  OPACITY_PICKER: 'OpacityPicker',
  PALETTE: 'Palette',
  PALETTE_DIALOG: 'PaletteDialog',
  PALETTE_PICKER: 'PalettePicker',
  PALETTE_PICKER_DIALOG: 'PalettePickerDialog',
  PANEL_HEADER: 'PanelHeader',
  PRELOADER: 'Preloader',
  PROGRESS_BAR: 'ProgressBar',
  PROMOTIONAL_LIST: 'PromotionalList',
  PROMOTIONAL_MODAl: 'PromotionalModal',
  RADIO_BUTTON: 'RadioButton',
  RADIO_BUTTONS: 'RadioButtons',
  RESET_COLOR: 'ResetColor',
  RICH_TEXT: 'RichText',
  SECONDARY_MEDIA_IMAGE: 'SecondaryMediaImage',
  SECTION_DIVIDER: 'SectionDivider',
  SLIDER: 'Slider',
  SORT_BY_DRAG_LIST: 'SortByDragList',
  SORT_BY_DRAG_LIST_ITEM_ROW_BASE: 'SortByDragListItemRowBase',
  SORT_BY_DRAG_LIST_ITEM_ROW: 'SortByDragListItemRow',
  SORT_BY_DRAG_LIST_CUSTOM_ITEM_ROW: 'SortByDragListCustomItemRow',
  SORT_BY_DRAG_LIST_TEXT_EDIT: 'SortByDragListTextEdit',
  Symbol: 'Symbol',
  Spacer: 'Spacer',
  TAB: 'Tab',
  TEXT_FORMATTING: 'TextFormatting',
  VERTICAL_TABS: 'VerticalTabs',
  VERTICAL_TABS_CUSTOM: 'VerticalTabsCustom',
  TEXT_FORMATTING_TOGGLE_BUTTON: 'TextFormattingToggleButton',
  TEXT_BUTTON: 'TextButton',
  TEXT_BOLD_BUTTON: 'TextFormatting.bold',
  TEXT_COLOR_BUTTON: 'TextFormatting.color',
  TEXT_HIGHLIGHT_BUTTON: 'TextFormatting.highlight',
  TEXT_CUSTOM_BUTTON: 'TextFormatting.custom',
  TEXT_ITALIC_BUTTON: 'TextFormatting.italic',
  TEXT_UNDERLINE_BUTTON: 'TextFormatting.underline',
  TEXT_INPUT: 'TextInput',
  TEXT_INPUT_MULTI_LINE: 'TextInputMultiline',
  TEXT_INPUT_MULTI_LINE_WITH_BUTTON: 'TextInputMultilineWithButton',
  TEXT_LABEL: 'TextLabel',
  TEXT_LABEL_BASE: 'TextLabelBase',
  TEXT_LINK_BUTTON: 'TextFormatting.link',
  THUMBNAIL: 'Thumbnail',
  GALLERY_CARD: 'GalleryCard',
  THUMBNAIL_BUTTON_GROUP: 'ThumbnailButtonGroup',
  THUMBNAIL_COLOR_INPUT: 'ThumbnailColorInput',
  THUMBNAILS: 'Thumbnails',
  TOGGLE: 'Toggle',
  TOGGLE_SWITCH: 'ToggleSwitch',
  TOOLTIP: 'Tooltip',
  TOOLTIP_ON_ELLIPSIS: 'TooltipOnEllipsis',
  UPLOAD_BUTTON: 'UploadButton',
  UPLOAD_BUTTON_STATUS_MESSAGE: 'UploadButtonStatusMessage',
  INPUT_WITH_CONFIRM: 'InputWithConfirm',
  PANEL_FOOTER: 'PanelFooter',
  TREE_LIST_ITEM: 'TreeListItem',
  TREE_SECTION_DIVIDER: 'TreeSectionDivider',
  CORVID_SITE_STRUCTURE: 'CorvidSiteStructure',
  ICON_BUTTON: 'IconButton',
  STEPPER: 'Stepper',
  ACTION_ITEM: 'ActionItem',
  CHAR_LIMIT: 'CharLimit',
  SEARCH: 'Search',
  TEXT: 'Text',
  HEADING: 'Heading',
  NOTIFICATION_BANNER: 'NotificationBanner',
  BADGE_INDICATOR: 'BadgeIndicator',
  CIRCULAR_PROGRESS_BAR: 'CircularProgressBar',
  POPOVER: 'Popover',
  SETTINGS_PANEL_CONTAINER: 'SettingsPanelContainer',
  CONTROL_HEADER: 'ControlHeader',
  MULTISELECT: 'MultiSelect'
};